export default __webpack_public_path__ + "static/moneybus_cover-big_1-c827cc8d1d130a62701c83063903b7ab.png";